import { useEffect } from 'react';
import { useAuthStore } from '../store/authStore';
import { useNavigate } from 'react-router-dom';
import { getTelegramInitData } from '../utils/telegram';
import './AuthPage.css';

export function AuthPage() {
  const { initAuth, isAuthenticated } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
      return;
    }

    // Wait a bit for Telegram WebApp to initialize
    const timer = setTimeout(() => {
      console.log('Attempting to get Telegram initData...');
      console.log('window.Telegram?.WebApp:', window.Telegram?.WebApp);
      console.log('window.location.hash:', window.location.hash);
      console.log('window.location.search:', window.location.search);
      
      const initData = getTelegramInitData();
      console.log('Extracted initData:', initData ? `${initData.substring(0, 50)}...` : 'null');
      
      if (initData) {
        console.log('Calling initAuth with initData...');
        initAuth(initData)
          .then(() => {
            console.log('Auth successful, navigating to home');
            navigate('/');
          })
          .catch((error) => {
            console.error('Auth error:', error);
            const errorMessage = error.response?.data?.error?.message || error.message || 'Ошибка авторизации';
            if (window.Telegram?.WebApp?.showAlert) {
              window.Telegram.WebApp.showAlert(`Ошибка: ${errorMessage}`);
            } else {
              alert(`Ошибка: ${errorMessage}`);
            }
          });
      } else {
        console.warn('No Telegram initData available');
        if (window.Telegram?.WebApp?.showAlert) {
          window.Telegram.WebApp.showAlert('Ошибка авторизации: отсутствуют данные Telegram. Попробуйте перезагрузить страницу.');
        } else {
          alert('Ошибка: данные Telegram не найдены. Убедитесь, что приложение открыто через Telegram.');
        }
      }
    }, 200);

    return () => clearTimeout(timer);
  }, [initAuth, isAuthenticated, navigate]);

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h1>Numbermania</h1>
        <p>Авторизация через Telegram...</p>
      </div>
    </div>
  );
}

